export class Fornecedor {
  constructor({ id, nome, fantasia, cnpj }) {
    this.id = id;
    this.nome = nome;
    this.fantasia = fantasia;
    this.cnpj = cnpj;
  }
}
